import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Equipment, EquipmentListGetResponse, EquipmentListQuery, EquipmentUpdate } from '../../../shared/interfaces/equipment.interfaces';
import { Observable } from 'rxjs';

const basePath = '/equipment';

@Injectable({
  providedIn: 'root',
})

export class EquipmentService {
  constructor(private http: HttpClient) { }

  // Gets a list of equipments for the current dealer
  getEquipments(query?: EquipmentListQuery, currentPage?: number): Observable<EquipmentListGetResponse> {
    const params = new HttpParams()
      .set('rows', (query?.rows ?? 10).toString())
      .set('first', ((currentPage ?? 0) * (query?.rows ?? 10)).toString())
      .set('sort_order', (query?.sort_order ?? 1).toString())
      .set('sort_field', query?.sort_field ?? 'id')
      .set('filters', JSON.stringify(query?.filters ?? {}));
    return this.http.get<EquipmentListGetResponse>(`${basePath}`, { params });
  }

  // Gets details of a specific equipment
  getEquipmentById(id: string | number | null): Observable<Equipment> {
    return this.http.get<Equipment>(`${basePath}/${id}`);
  }

  // Updates an equipment's details, for example its name
  updateEquipment(payload: EquipmentUpdate) {
    const body = {
      name: payload.name
    }
    return this.http.put(`${basePath}/${payload.id}`, body);
  }

  // Unassigns an equipment from the current dealer and sends it to it's parent dealer
  unassignEquipmentFromDealer(id: number) {
    return this.http.delete(`${basePath}/${id}`);
  }

}
